import { render } from "./humanitySubjectMuseum.vue?vue&type=template&id=2741624e&scoped=true"
import script from "./humanitySubjectMuseum.vue?vue&type=script&lang=js"
export * from "./humanitySubjectMuseum.vue?vue&type=script&lang=js"

import "./humanitySubjectMuseum.vue?vue&type=style&index=0&id=2741624e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2741624e"]])

export default __exports__